import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { changeLayout, changeSidebarTheme, changeSidebarType, toggleRightSidebar, changeTopbarTheme, changeLayoutWidth, toggleInfobar } from "../../store/actions";

// Layout Related Components
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import Rightbar from "../CommonForBoth/Rightbar";
import ToastMessage from "../../pages/Utility/ToastMessage";
import { popUpConfirm, removeActionablePopUp, removeToastMessage } from "../../store/dbFilter/actions";
import ActionablePopUp from "../../pages/Utility/ActionablePopUp";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
    };
    this.toggleMenuCallback = this.toggleMenuCallback.bind(this);
    this.toggleRightSidebar = this.toggleRightSidebar.bind(this);
  }

  toggleRightSidebar() {
    this.props.toggleRightSidebar();
  }

  capitalizeFirstLetter = (string) => {
    return string.charAt(1).toUpperCase() + string.slice(2);
  };

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (this.props.isPreloader === true) {
        document.getElementById("preloader").style.display = "block";
        document.getElementById("status").style.display = "block";

        setTimeout(function () {
          document.getElementById("preloader").style.display = "none";
          document.getElementById("status").style.display = "none";
        }, 2500);
      } else {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }
    }
  }

  componentDidMount() {
    // Scroll Top to 0
    window.scrollTo(0, 0);
    let currentage = this.capitalizeFirstLetter(this.props.location.pathname);

    document.title = currentage + " | iqlabs.io CSMS";
    if (this.props.leftSideBarTheme) {
      this.props.changeSidebarTheme(this.props.leftSideBarTheme);
    }

    if (this.props.layoutWidth) {
      this.props.changeLayoutWidth(this.props.layoutWidth);
    }

    if (this.props.leftSideBarType) {
      this.props.changeSidebarType(this.props.leftSideBarType);
    }
    if (this.props.topbarTheme) {
      this.props.changeTopbarTheme(this.props.topbarTheme);
    }

    if (this.props.showRightSidebar) {
      this.toggleRightSidebar();
    }

    if (this.props.infobarType) {
      this.props.toggleInfobar(this.props.infobarType);
    }
  }
  toggleMenuCallback = () => {
    if (this.props.leftSideBarType === "default") {
      this.props.changeSidebarType("condensed", this.state.isMobile);
    } else if (this.props.leftSideBarType === "condensed") {
      this.props.changeSidebarType("default", this.state.isMobile);
    }
  };

  render() {
    return (
      <React.Fragment>
        <div id="preloader">
          <div id="status">
            <div className="spinner">
              <i className="ri-loader-line spin-icon"></i>
            </div>
          </div>
        </div>

        <div id="layout-wrapper">
          <Header toggleMenuCallback={this.toggleMenuCallback} toggleRightSidebar={this.toggleRightSidebar} />
          {this.props.toast?.map((toast) => (
            <ToastMessage key={toast.id} toastData={toast} onClose={() => this.props.removeToastMessage(toast.id)} />
          ))}
          <div style={{ ...styles.overlay, display: this.props.popUp?.length > 0 ? "block" : "none" }}>
            {this.props.popUp?.map((item, index) => (
              <ActionablePopUp
                key={item.id}
                popUpData={item}
                index={index}
                onClose={(response) => {
                  if (response) {
                    this.props.popUpConfirm(item.id, item?.popUpType);
                  }
                  this.props.removeActionablePopUp(item.id, response);
                }}
              />
            ))}
          </div>
          <Sidebar theme={this.props.leftSideBarTheme} type={this.props.leftSideBarType} isMobile={this.state.isMobile} />
          <div className="main-content">
            {this.props.children}
            <Footer />
          </div>
        </div>
        <Rightbar />
      </React.Fragment>
    );
  }
}

const styles = {
  overlay: {
    position: "fixed",
    height: "100%",
    width: "100%",
    top: "0",
    left: "0",
    backgroundColor: "rgba(0,0,0,0.6)",
    zIndex: "10001",
  },
};

const mapStatetoProps = (state) => {
  const { toast, popUp } = state.sharedData;
  return {
    ...state.Layout,
    toast,
    popUp,
  };
};
export default connect(mapStatetoProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  toggleRightSidebar,
  changeTopbarTheme,
  changeLayoutWidth,
  toggleInfobar,
  removeToastMessage,
  removeActionablePopUp,
  popUpConfirm,
})(withRouter(Layout));
